export const systemInfoManagement = {
    all: 'All',
    title: 'System information management',
    new: 'Sign up',
    edit: 'Edit',
    tableColumnId: 'ID',
    tableColumnTitle: 'Title',
    tableColumnStatus: 'Status',
    tableColumnCreater: 'Last updated person',
    tableColumnCreateDate: 'Last updated date',
    tableColumnEffectiveDate: 'Validity period',
    updater: 'Last updated person',
    updateDate: 'Last updated date',
    cancelText: 'Cancel',
    delText: 'Delete',
    saveText: 'Save',
    openText: 'Release',
    closeText: 'Private',
    modaleffectiveDate: 'Expiration date',
    modaltitle: 'Title',
    modalcontext: 'Text',
    required: 'Please enter.',
    plan: 'Contract plan',
    status: 'Status',
    no: 'None',
    tableColumnPlan: 'Contract plan',
    successMsg: 'Processing ended normally.',
    errorMsg: 'Processing failed.'
}
